
import React from 'react';
import PageLayout from '@/components/Layout/PageLayout';
import { UserDetails } from '@/components/auth/UserDetails';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { LoginHistory } from '@/components/auth/LoginHistory';
import { useUserSession } from '@/hooks/useUserSession';
import AccessDenied from '@/components/AccessDenied';

const StaffPage: React.FC = () => {
  // Update to use isLoading instead of isLoaded for consistency
  const { user, isLoading } = useUserSession();

  // if (!user || user.role !== 'admin') return <AccessDenied />;

  const staffRole = user?.role || 'Unknown';
  const authLevel = user?.auth_level || 'read';
  const firstName = user?.first_name || 'Staff';

  return (
    <PageLayout>
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-8">Staff Dashboard</h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Card>
            <CardHeader>
              <CardTitle>Welcome, {firstName}</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="mb-4">
                This is the staff portal where you can manage patient records and appointments.
              </p>
              <p>Your role: <strong>{staffRole}</strong></p>
              <p>Authorization level: <strong>{authLevel}</strong></p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Quick Actions</CardTitle>
            </CardHeader>
            <CardContent>
              <ul className="list-disc pl-5 space-y-2">
                <li>View appointment schedule</li>
                <li>Process patient check-ins</li>
                <li>Update patient records</li>
                <li>View doctor schedules</li>
              </ul>
            </CardContent>
          </Card>
        </div>

        {/* <div className="mt-8">
          <UserDetails />
        </div> */}

        <div className="mt-8">
          <LoginHistory />
        </div>
      </div>
    </PageLayout>
  );
};

export default StaffPage;
